// UserAvatar.tsx
import { useEffect, useState } from "react";
import { Avatar } from "@mantine/core";
import { useMsal } from "@azure/msal-react";
import { graphRequest } from "./authConfig";

export function UserAvatar() {
  const { instance } = useMsal();
  const [photoUrl, setPhotoUrl] = useState<string | null>(null);

  useEffect(() => {
    const run = async () => {
      const account = instance.getActiveAccount() || instance.getAllAccounts()[0];
      if (!account) return;

      try {
        const { accessToken } = await instance.acquireTokenSilent({
          ...graphRequest,
          account,
        });

        const res = await fetch("https://graph.microsoft.com/v1.0/me/photo/$value", {
          headers: { Authorization: `Bearer ${accessToken}` },
        });

        if (!res.ok) throw new Error("No photo");
        const blob = await res.blob();
        setPhotoUrl(URL.createObjectURL(blob));
      } catch {
        setPhotoUrl(null); // fallback: visa initialer
      }
    };
    run();
  }, [instance]);

  const name = instance.getActiveAccount()?.name || instance.getAllAccounts()[0]?.name || "U";

  const initials = name
    .split(" ")
    .map((p) => p[0])
    .join("")
    .slice(0, 2)
    .toUpperCase();

  return (
    <Avatar src={photoUrl ?? undefined} radius="xl">
      {!photoUrl && initials}
    </Avatar>
  );
}
